import { IssueCaseDoc, IssueTaskDoc } from '@gooduncles/gu-app-schema';
import { PresetStatusColorType } from 'antd/es/_util/colors';

import { getCategoryLabel, getSubcategoryLabel } from 'src/utils/issue/issue-data-util';
import { issueCaseStatusBadgeMap } from 'src/utils/issue/issue-util';

/** CRM 보드 ag-grid Row 데이터 (현재는 IssueCase 단일 소스) */
export interface CrmUnifiedRowData {
  _id: string;
  storeId: string;
  storeName: string;
  registeredAt: string;
  status: number;
  statusText: string;
  statusBadgeType: PresetStatusColorType;
  displayCategory: string;
  displaySubcategory: string | null;
  publicNote: string | null;
  privateNote: string | null;
  issueTasks: IssueTaskDoc[];
  /** 접수 유형 (issuedBy) */
  requestedBy: string | null;
  /** 연결된 ChannelMessage 수 (confirmed). legacy 케이스(linkedMessageStats=null)는 0 */
  linkedMessageCount: number;
  originalData: IssueCaseDoc;
}

const convertIssueCaseToUnifiedRow = (issueCase: IssueCaseDoc, tasks: IssueTaskDoc[]): CrmUnifiedRowData => {
  const badgeInfo = issueCaseStatusBadgeMap[issueCase.status];
  const categoryLabel = getCategoryLabel(issueCase.category);
  const subcategoryLabel = issueCase.subcategory
    ? getSubcategoryLabel(issueCase.category, issueCase.subcategory)
    : null;

  return {
    _id: issueCase._id,
    storeId: issueCase.storeId,
    storeName: issueCase.storeName,
    registeredAt: issueCase.registeredAt,
    status: issueCase.status,
    statusText: badgeInfo?.text ?? String(issueCase.status),
    statusBadgeType: badgeInfo?.status ?? 'default',
    displayCategory: subcategoryLabel ? `${categoryLabel} / ${subcategoryLabel}` : categoryLabel,
    displaySubcategory: subcategoryLabel,
    publicNote: issueCase.publicNote,
    privateNote: issueCase.privateNote,
    issueTasks: tasks.filter((task) => task.issueCaseId === issueCase._id),
    requestedBy: issueCase.issuedBy,
    linkedMessageCount: issueCase.linkedMessageStats?.confirmedCount ?? 0,
    originalData: issueCase,
  };
};

/** IssueCase 목록을 CrmUnifiedRowData 배열(registeredAt 내림차순)로 변환 */
export const processUnifiedCrmData = (issues: IssueCaseDoc[], tasks: IssueTaskDoc[] = []): CrmUnifiedRowData[] =>
  issues
    .map((issue) => convertIssueCaseToUnifiedRow(issue, tasks))
    .sort((a, b) => b.registeredAt.localeCompare(a.registeredAt));
